export const creation = {
	data() {
		return {
			tabs: {
				templates: {
					name: 'Templates',
					route: {
						path: 'templates',
						params: { tab: 'popup' },
					},
				},
				playbooks: {
					name: 'Playbooks',
					route: {
						path: 'playbooks',
						params: {},
					},
				},
			},
		};
	},
};
